var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{staticClass:"gizmodate",class:_vm.status},[_c('svg',{attrs:{"height":"22","width":"22"}},[_c('use',{attrs:{"xlink:href":require("@/assets/icons/clock.svg") + "#clock"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }